import React, { useContext } from 'react';
import EmbeddedContext from '../../configuration/context/embedded';
import { purify } from '../../utils/helpers';
import { Type } from '@spotify-internal/encore-web';
function LegalTerms(props) {
    const { className } = props;
    let { text } = props;
    const { isEmbedded } = useContext(EmbeddedContext);
    const targetRegex = /href="([^"]*)"/gim;
    if (isEmbedded) {
        text = text.replace(targetRegex, (_target, match) => {
            return match.includes('/legal/')
                ? `href="${match}${match.endsWith('/') ? '' : '/'}plain/"`
                : `href="${match}"`;
        });
    }
    return (React.createElement(Type.p, { className: className, variant: "finale", dangerouslySetInnerHTML: {
            __html: purify(text),
        } }));
}
export default LegalTerms;
//# sourceMappingURL=legalTerms.js.map